app.service('customerPersonalDataVerificationModal', function (loading, modal, console, pageConfig) {
	let $self, $personalDataUpdate, $personalDataConfirm;
	let closeActionType, verificationPopupType;
	const modalId = 'customer-personal-data-verification-modal';

	function open() {
		loading.start();
		$.ajax({
			url:'/customer-personal-data-verification.ltr',
			success: function(html) {
				loading.stop();
				if (html){
					modal.generate({
						id: modalId,
						content: html,
						callbackClose: function () {
							close();
						},
						callbackOpen: function () {
							setElements();
							setEvents();
						}
					});
				}
			},
			error: function () {
				loading.stop();
				console.log('Błąd pobierania danych użytkownika');
			}
		});
	}

	function close() {
		send(closeActionType ? closeActionType : 'CLOSE');
	}
	function send(action) {
		$.ajax({
			url: '/customer-personal-data-verification.ltr',
			type: 'POST',
			data: {
				actionType: action,
				popupType: verificationPopupType,
			},
			success: function (response) {
				if (response.status == 'SUCCESS' && action == 'UPDATE_DATA') {
					loading.redirect('/customer-password.bhtml');
				}
			}
		});
	}

	function setElements() {
		$self = $('#customer-personal-data-verification-modal');
		$personalDataUpdate = $('.js-personal-data-update', $self);
		$personalDataConfirm = $('.js-personal-data-confirm', $self);
		verificationPopupType = $('#customer-personal-data-content', $self).data('popup-type');
	}
	function setEvents() {
		$personalDataConfirm.on('click', function () {
			closeActionType = 'UP_TO_DATE';
			modal.close();
		});
		$personalDataUpdate.on('click', function () {
			closeActionType = 'UPDATE_DATA';
			modal.close();
		})
	}

	function init() {
		let config = pageConfig.getData('account');
		if(config.showPersonalDataVerificationPopup) {
			open();
		}
	}
	return {
		init
	};
});